import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[appAlphaNumeric]',
    standalone: false
})
export class AlphaNumericDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const inputElement = this.el.nativeElement;
    const initialValue = inputElement.value;
    const sanitizedValue = initialValue.replace(/[^a-zA-Z0-9\s]/g, '');
    inputElement.value = sanitizedValue;

    if (initialValue !== sanitizedValue) {
      event.stopPropagation();
    }

    this.control?.control?.setValue(sanitizedValue, { emitEvent: false });
  }
}
